import { render, staticRenderFns } from "./ListDBs.vue?vue&type=template&id=de7bd620"
import script from "./ListDBs.vue?vue&type=script&lang=ts"
export * from "./ListDBs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports